// extracted by mini-css-extract-plugin
module.exports = {"OfficeCard_heading":"OfficeCard_OfficeCard_heading__ELqrh","OfficeCard_textbox":"OfficeCard_OfficeCard_textbox__LQz9X"};